import React from 'react';
import SalesForm from '../SalesForm';

const SaleProductsPage = ({ onNavigate }) => {
  return <SalesForm onNavigate={onNavigate} />;
};

export default SaleProductsPage;
